import React from "react"
import { useStore } from "../../../stores/RootStoreContext"
import { ReplenishmentClient } from "../../client/replenishment/ReplenishmentClient"
import { ReplenishmentManager } from "../../manager/replenishment/ReplenishmentManager"

export const Replenishment = () => {
  const { userStore } = useStore()

  if (userStore.isClient) {
    return <ReplenishmentClient />
  } else if (userStore.isManagement) {
    return <ReplenishmentManager />
  } else {
    return <></>
  }
}
